import {
  AIModelType,
  AIObjectPropertyType,
  DeploymentStatus,
  GraphElementType,
  IterationStatus,
  ProjectType,
  UniqueAIObjectConnectionType,
  VQAModelType,
} from '@tabeeb/contracts/microservices/swagger-ai-service'

export { AutofillSource, AutofillSourceDisplayName } from './AutofillSource'

export const AIModelTypeDisplayName = {
  [AIModelType.CustomVision]: 'Custom Vision',
  [AIModelType.External]: 'General',
  [AIModelType.InternalTrained]: 'Collaborate',
  [AIModelType.HuggingFace]: 'Hugging Face',
  [AIModelType.Roboflow]: 'Roboflow',
}

export const VQAModelTypeDisplayName = {
  [VQAModelType.External]: 'General',
  [VQAModelType.InternalTrained]: 'Collaborate',
}

export const ProjectTypeDisplayName = {
  [ProjectType.VQA]: 'Visual Question Answering',
  [ProjectType.ImageClassification]: 'Image Classification',
  [ProjectType.ObjectDetection]: 'Object Detection',
}

export const IterationStatusDisplayName = {
  [IterationStatus.NotStarted]: 'Not started',
  [IterationStatus.Starting]: 'Starting',
  [IterationStatus.Provisioning]: 'Provisioning',
  [IterationStatus.Preparing]: 'Preparing',
  [IterationStatus.Queued]: 'Queued',
  [IterationStatus.Running]: 'Running',
  [IterationStatus.Finalizing]: 'Finalizing',
  [IterationStatus.CancelRequested]: 'CancelRequested',
  [IterationStatus.Completed]: 'Completed',
  [IterationStatus.Failed]: 'Failed',
  [IterationStatus.Canceled]: 'Canceled',
  [IterationStatus.NotResponding]: 'NotResponding',
  [IterationStatus.SentToStart]: 'Sent for processing',
  [IterationStatus.FailedToSendToStart]: 'Failed to be sent for processing',
}

export const IterationDeploymentStatusDisplayName = {
  [DeploymentStatus.NotDeployed]: 'Not deployed',
  [DeploymentStatus.Succeeded]: 'Running',
  [DeploymentStatus.Stopped]: 'Stopped',
  [DeploymentStatus.Failed]: 'Failed',
  [DeploymentStatus.Creating]: 'Creating endpoint',
  [DeploymentStatus.Updating]: 'Deploying',
  [DeploymentStatus.Deleting]: 'Deleting',
  [DeploymentStatus.SentToDeploy]: 'Sent for deployment',
  [DeploymentStatus.FailedToSendToDeploy]: 'Failed to be sent for deployment',
}

export const AIObjectPropertyTypeDisplayName = {
  [AIObjectPropertyType.Json]: 'Json',
  [AIObjectPropertyType.String]: 'String',
  [AIObjectPropertyType.IntNumber]: 'Integer',
  [AIObjectPropertyType.DoubleNumber]: 'Floating point number (float)',
  [AIObjectPropertyType.DateTime]: 'Date and time',
  [AIObjectPropertyType.Dropdown]: 'Dropdown',
  // [AIObjectPropertyType.Checkbox]: 'Checkbox',
  [AIObjectPropertyType.Url]: 'Url',
  [AIObjectPropertyType.Boolean]: 'Boolean',
  [AIObjectPropertyType.Latitude]: 'Latitude',
  [AIObjectPropertyType.Longitude]: 'Longitude',
}

export const GraphElementTypeDisplayName = {
  [GraphElementType.None]: 'None',
  [GraphElementType.Node]: 'Node',
  [GraphElementType.Edge]: 'Edge',
  [GraphElementType.EdgeDirected]: 'Edge directed',
}

export const UniqueAIObjectConnectionTypeDisplayName = {
  [UniqueAIObjectConnectionType.Link]: 'Link',
  [UniqueAIObjectConnectionType.Projection]: 'Projection',
  [UniqueAIObjectConnectionType.Intersection]: 'Intersection',
}
